import { ConditionalPartial } from '../../../../utils';

import { CreateMedicalDeviceReleaseConfigRequestDto } from './create-medical-device-release-config.request.dto';

/**
 * DTO for updating medical device release configuration
 * All fields are optional for partial updates
 */
export class UpdateMedicalDeviceReleaseConfigRequestDto extends ConditionalPartial(
    CreateMedicalDeviceReleaseConfigRequestDto,
) {}
